var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGetDirection = function SvgGetDirection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 11c-.827 0-1.5-.674-1.5-1.5 0-.828.673-1.5 1.5-1.5s1.5.672 1.5 1.5c0 .826-.673 1.5-1.5 1.5Zm0-5C10.57 6 9 7.57 9 9.5s1.57 3.5 3.5 3.5S16 11.43 16 9.5 14.43 6 12.5 6Zm0 13.646c-1.675-1.584-6-6.031-6-9.724C6.5 6.657 9.191 4 12.5 4s6 2.657 6 5.922c0 3.693-4.325 8.14-6 9.724ZM12.5 2c-4.411 0-8 3.553-8 7.922 0 5.475 7.049 11.579 7.349 11.836a.998.998 0 0 0 1.302 0c.3-.257 7.349-6.361 7.349-11.836C20.5 5.553 16.911 2 12.5 2Z",
    fill: "#008545"
  })));
};
export default SvgGetDirection;